// extracted by mini-css-extract-plugin
export default {"textarea-label":"NoteReasonForm_textarea-label__ityNt","buttons":"NoteReasonForm_buttons__UKan7"};